import { Box, BoxProps, useTheme } from '@mui/material';
import { ReactNode } from 'react';

interface ResponsiveFormContainerProps extends Omit<BoxProps, 'children'> {
  children: ReactNode;
  /** Maximum width of each column on larger screens */
  maxColumnWidth?: number;
  /** Minimum width of each column on larger screens */
  minColumnWidth?: number;
  /** Gap between columns */
  gap?: number;
}

export const ResponsiveFormContainer = ({
  children,
  maxColumnWidth = 400,
  minColumnWidth = 200,
  gap = 2,
  sx,
  ...props
}: ResponsiveFormContainerProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        gap,
        flexDirection: { xs: 'column', sm: 'row' },
        '& > *': {
          flex: { xs: '1 1 100%', sm: `1 1 0` },
          minWidth: { xs: 'unset', sm: `${minColumnWidth}px` },
          maxWidth: { xs: '100%', sm: `${maxColumnWidth}px` },
          // Use standard breakpoints instead of hardcoded values
          [theme.breakpoints.down('lg')]: {
            flex: '1 1 100%',
            minWidth: 'unset',
            maxWidth: '100%',
          },
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
